import React, { Component } from "react";
import { propertyOperators } from "@appcues/libcues";
import moment from "moment";
import { millisecondsPerDay } from "constants/account/conditions";
import ToggleableSelect from "components/Common/Clauses/ToggleableSelect";
import ToggleableInput from "components/Common/Clauses/ToggleableInput";
import "components/Common/UserHistoryDateRange/style.scss";

export default class UserHistoryDateRange extends Component {
  render() {
    const { clause, readOnly, updateClause } = this.props;

    const operator = clause.operator || "ever";
    const times = clause.times === undefined ? 1 : clause.times;

    const value =
      operator === "since" && clause.value === "0" ? "ever" : operator;

    const relativeTimeDisplayMap = {
      ever: "previously",
      [propertyOperators.SINCE]: "since",
      [propertyOperators.LESS_THAN_X_DAYS_AGO]: "in the last"
    };

    const relativeTimeDisplay = relativeTimeDisplayMap[value];
    const datePickerDisplayTime = moment(parseInt(clause.value, 10)).format(
      "L"
    );

    return (
      <div className="user-history-date-range">
        At least
        <ToggleableInput
          type="text"
          value={times}
          onChange={e =>
            updateClause(clause.id, {
              times:
                e.target.value && parseInt(e.target.value, 10)
                  ? parseInt(e.target.value || 0, 10)
                  : ""
            })
          }
          readOnly={readOnly}
          readOnlyContent={times}
        />
        <span>{times === 1 ? "time" : "times"}</span>
        <ToggleableSelect
          readOnly={readOnly}
          readOnlyContent={relativeTimeDisplay}
          value={
            operator === "since" && clause.value === "0" ? "ever" : operator
          }
          className="select-relative-time-operator"
          clearable={false}
          options={[
            { value: "ever", label: "previously" },
            { value: propertyOperators.SINCE, label: "since" },
            {
              value: propertyOperators.LESS_THAN_X_DAYS_AGO,
              label: "in the last"
            }
          ]}
          onChange={opt => {
            switch (opt.value) {
              case "ever":
                updateClause(clause.id, {
                  operator: propertyOperators.SINCE,
                  value: "0"
                });
                break;

              case propertyOperators.SINCE:
                updateClause(clause.id, {
                  operator: propertyOperators.SINCE,
                  value: moment()
                    .startOf("day")
                    .format("x")
                });
                break;

              case propertyOperators.LESS_THAN_X_DAYS_AGO:
                updateClause(clause.id, {
                  operator: propertyOperators.LESS_THAN_X_DAYS_AGO,
                  value: millisecondsPerDay
                });
                break;

              default:
                break;
            }
          }}
          operator
        />
        {(() => {
          switch (operator) {
            case propertyOperators.SINCE:
              if (clause.value && clause.value !== "0") {
                return (
                  <ToggleableInput
                    datePicker
                    selected={moment(parseInt(clause.value, 10))}
                    onChange={date =>
                      updateClause(clause.id, {
                        value: date.startOf("day").format("x")
                      })
                    }
                    readOnly={readOnly}
                    readOnlyContent={datePickerDisplayTime}
                  />
                );
              }
              break;
            case propertyOperators.LESS_THAN_X_DAYS_AGO: {
              const numTrailingDays = clause.value
                ? clause.value / millisecondsPerDay
                : "";
              const dayDisplay = numTrailingDays === 1 ? " day" : " days";
              return (
                <div>
                  <ToggleableInput
                    type="text"
                    value={numTrailingDays}
                    onChange={e => {
                      const numDays = parseInt(e.target.value, 10);
                      if (e.target.value === "" || numDays) {
                        updateClause(clause.id, {
                          value: numDays ? numDays * millisecondsPerDay : ""
                        });
                      }
                    }}
                    readOnly={readOnly}
                    readOnlyContent={numTrailingDays}
                  />
                  {dayDisplay}
                </div>
              );
            }
            default:
              break;
          }

          return undefined;
        })()}
      </div>
    );
  }
}
